
export const BASE_URL = (() => {
  if (process.env.NODE_ENV === 'development') {
    return '/api'
  } else {
    let apiUrl = localStorage.getItem('apiUrl')
    if (apiUrl && apiUrl !== 'undefined') {
      return `${apiUrl}/api`
    } else {
      if (location.host.indexOf('dev') > -1) {
        return 'http://dev.copartner-api.ksaxshop.com/api'
      } else if (location.host.indexOf('test') > -1) {
        return 'http://test.copartner-api.ksaxshop.com/api'
      } else {
        return 'http://copartner-api.ksaxshop.com/api'
      } 
    }
  }
})()

export const SERVE_SITE_URL = (() => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://test.client-api.ksaxshop.com/api'
  } else {
    if (location.host.indexOf('test') === -1) {
      return 'http://client-api.ksaxshop.com/api'
    } else {
      return 'http://test.client-api.ksaxshop.com/api'
    }
  }
})()





// WEBPACK FOOTER //
// ./src/api/base.js